module.exports = __webpack_public_path__ + "static/media/book-solid.40d44f9a.svg";